import { render, staticRenderFns } from "./_Caixa_btn.vue?vue&type=template&id=48d21b6b&"
import script from "./_Caixa_btn.vue?vue&type=script&lang=js&"
export * from "./_Caixa_btn.vue?vue&type=script&lang=js&"
import style0 from "./_Caixa_btn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports